<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">修改邮箱</div>
    <div slot="body">
      <a-form :form="form.fc">
        <a-form-item label="手机号" v-bind="formItemLayout" v-if="this.step === 1">
          <a-input :value="params.mobile" disabled />
        </a-form-item>
        <a-form-item label="验证码" v-bind="formItemLayout" v-if="this.step === 1">
          <a-input-group>
            <a-row :gutter="8">
              <a-col :span="18">
                <a-input v-decorator="decorator.captcha" placeholder="请填写手机验证码" />
              </a-col>
              <a-col :span="6">
                <a-button :disabled="enableSendSmsCode" @click="sendMobileCaptcha" style="width: 100%">{{ enableSendSmsCode ? `已发送(${count})` : '获取手机验证码' }}</a-button>
              </a-col>
            </a-row>
          </a-input-group>
        </a-form-item>
        <a-form-item label="邮箱地址" v-bind="formItemLayout" v-if="this.step === 2">
          <a-input v-decorator="decorator.email" placeholder="请填写邮箱地址" />
        </a-form-item>
        <a-form-item label="验证码" v-bind="formItemLayout" v-if="this.step === 2">
          <a-input-group>
            <a-row :gutter="8">
              <a-col :span="18">
                <a-input v-decorator="decorator.mail_code" placeholder="请填写邮箱验证码" />
              </a-col>
              <a-col :span="6">
                <a-button :disabled="enableSendSmsCode" @click="sendEmailCaptcha" style="width: 100%">{{ enableSendSmsCode ? `已发送(${count})` : '获取邮箱验证码' }}</a-button>
              </a-col>
            </a-row>
          </a-input-group>
        </a-form-item>
      </a-form>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="next" v-if="this.step === 1" :disabled="!enableNext">下一步</a-button>
      <a-button type="primary" @click="handleConfirm" :loading="loading" v-if="this.step === 2">{{$t('dialog.ok')}}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'EditEamilDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      enableSendSmsCode: false,
      startCountDown: false,
      enableNext: false,
      isSendMobileCaptcha: false,
      count: 60,
      timer: null,
      token: null,
      step: 1,
      form: {
        fc: this.$form.createForm(this, {
          onValuesChange: (props, values) => {
            if (values.captcha && this.isSendMobileCaptcha) {
              this.enableNext = true
            }
          },
        }),
      },
      decorator: {
        email: [
          'email',
          { rules: [{ required: true, message: '请填写邮箱地址' }] },
        ],
        captcha: [
          'captcha',
          { rules: [{ required: true, message: '请填写验证码' }] },
        ],
        mail_code: [
          'mail_code',
          { rules: [{ required: true, message: '请填写验证码' }] },
        ],
      },
      formItemLayout: {
        wrapperCol: {
          span: 18,
        },
        labelCol: {
          span: 3,
        },
      },
    }
  },
  watch: {
    startCountDown (val) {
      if (val) {
        this.clearTimer()
        this.timer = setInterval(() => {
          if (this.count !== 0) {
            this.count--
          } else {
            this.enableSendSmsCode = false
            this.startCountDown = false
          }
        }, 1000)
      }
    },
  },
  destroyed () {
    this.clearTimer()
  },
  methods: {
    clearTimer () {
      clearInterval(this.timer)
      this.timer = null
    },
    initStatus () {
      this.enableSendSmsCode = false
      this.startCountDown = false
      this.count = 60
    },
    getToken (sms_code) {
      return new this.$Manager('customers').performAction({
        id: this.params.customerId,
        action: 'reset-token',
        data: {
          sms_code,
        },
      })
    },
    async next () {
      const { captcha: sms_code } = await this.form.fc.validateFields()
      const { data } = await this.getToken(sms_code)
      this.token = data.token
      this.step++
      this.clearTimer()
      this.initStatus()
    },
    async sendMobileCaptcha () {
      this.enableSendSmsCode = true
      try {
        await new this.$Manager('customers').performAction({
          id: this.params.customerId,
          action: 'sms-code',
          data: {
            mobile: this.params.mobile,
          },
        })
        this.startCountDown = true
        this.isSendMobileCaptcha = true
      } catch (error) {
        this.enableSendSmsCode = false
      }
    },
    async sendEmailCaptcha () {
      this.enableSendSmsCode = true
      const email = this.form.fc.getFieldValue('email')
      try {
        await new this.$Manager('customers').performAction({
          id: this.params.customerId,
          action: 'mail-code',
          data: {
            email,
            token: this.token,
          },
        })
        this.count = 60
        this.startCountDown = true
      } catch (error) {
        this.enableSendSmsCode = false
      }
    },
    doUpdate (data) {
      return new this.$Manager('customers').performAction({
        id: this.params.customerId,
        action: 'reset-email',
        data,
      })
    },
    async handleConfirm () {
      this.loading = true
      try {
        const value = await this.form.fc.validateFields()
        const params = {
          email: value.email,
          mail_code: value.mail_code,
          token: this.token,
        }
        await this.doUpdate(params)
        this.loading = false
        this.cancelDialog()
        this.$message.success('邮箱修改成功')
        this.$store.dispatch('app/getEnterPriseInfo')
        this.$store.dispatch('app/getCustomerCapabilities')
      } catch (error) {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="less" scoped>
.captcha-img {
  height: 28px;
  width: 98px;
}
</style>
